import { jsx as p, jsxs as C } from "react/jsx-runtime";
import { c as k } from "./index-65016bfa.mjs";
import { useMemo as S, useRef as N } from "react";
import f, { css as w } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as _ } from "./useQuantum-50e8fd44.mjs";
import { a as b, i as T } from "./isClient-ec947a14.mjs";
import { c as D } from "./cloneSlots-333ddef1.mjs";
import { b as y } from "./useSlots-a1aa6a84.mjs";
import { Divider as g } from "./divider.js";
import { Text as x } from "./text.js";
import { u as L } from "./useClient-0bbce34e.mjs";
import { PopupTip as F } from "./popupTip.js";
import { IconButton as H } from "./iconButton.js";
import { Tooltip as O } from "./tooltip.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./closeButton.js";
import "./icon.js";
import "@fcamna/shared-icons";
import "./focusTrap.js";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
const P = ({
  pageUrl: o,
  params: n,
  className: t,
  ...e
}) => {
  var a;
  const i = L(), s = S(() => o || I(), [o]);
  return /* @__PURE__ */ p(
    l,
    {
      ...e,
      iconName: "facebook",
      className: k(["ShareOnFacebook", t]),
      shareToUrl: "https://www.facebook.com/sharer/sharer.php",
      params: {
        u: s,
        quote: (a = i.document) == null ? void 0 : a.title,
        ...n
      }
    }
  );
}, A = ({
  pageUrl: o,
  params: n,
  className: t,
  ...e
}) => {
  var a;
  const i = L(), s = S(() => o || I(), [o]);
  return /* @__PURE__ */ p(
    l,
    {
      ...e,
      iconName: "linkedIn",
      className: k(["ShareOnLinkedIn", t]),
      shareToUrl: "https://www.linkedin.com/shareArticle",
      params: {
        url: s,
        title: (a = i.document) == null ? void 0 : a.title,
        mini: !0,
        ...n
      }
    }
  );
}, R = ({
  pageUrl: o,
  params: n,
  className: t,
  ...e
}) => {
  var a;
  const i = L(), s = S(() => o || I(), [o]);
  return /* @__PURE__ */ p(
    l,
    {
      ...e,
      iconName: "x",
      className: k(["ShareOnTwitter", t]),
      shareToUrl: "https://twitter.com/intent/tweet/",
      params: {
        url: s,
        text: (a = i.document) == null ? void 0 : a.title,
        ...n
      }
    }
  );
}, I = () => {
  if (!(b && T("URL")))
    return;
  const n = new window.URL(window.location.href);
  return n.search = "", n.toString();
}, l = ({ shareToUrl: o, params: n = {}, title: t, tooltipPlacement: e = "bottom", className: i, hidden: s, ...a }) => {
  const c = N(b && T("URL")), r = S(() => {
    if (!c.current || !o)
      return;
    const m = new window.URL(o);
    return Object.entries(n).forEach(([h, d]) => m.searchParams.append(h, d)), m.toString();
  }, [o, n]);
  if (!s)
    return /* @__PURE__ */ p(
      O,
      {
        className: "Share-tooltip",
        title: t,
        placement: e,
        isDisabled: !(t != null && t.trim().length),
        children: /* @__PURE__ */ p(
          H,
          {
            href: r,
            renderAs: "a",
            ...a,
            size: "medium",
            variant: "tertiary",
            className: k(["ShareIcon", i])
          }
        )
      }
    );
};
l.Facebook = P;
l.LinkedIn = A;
l.Twitter = R;
const $ = f(F)`
  &.CopyLinkIcon-popuptip {
    ${({
  theme: {
    components: { shareLinks: o }
  }
}) => w(o.PopupTip)};
  }
`, j = ({
  pageUrl: o,
  onCopiedText: n = "Copied!",
  className: t,
  ...e
}) => {
  const i = L(), s = S(() => o || I(), [o]), a = (r) => {
    var m, h, d;
    (m = e.onClick) == null || m.call(e, r), r == null || r.preventDefault(), !(!i.isClient || !s) && ((d = (h = i.window) == null ? void 0 : h.navigator) == null || d.clipboard.writeText(s));
  }, c = (r) => {
    var m, h, d;
    (m = e.onKeyDown) == null || m.call(e, r), r == null || r.preventDefault(), (r.code === "Enter" || r.code === "Space") && (!i.isClient || !s || (d = (h = i.window) == null ? void 0 : h.navigator) == null || d.clipboard.writeText(s));
  };
  return /* @__PURE__ */ p(
    $,
    {
      className: "CopyLinkIcon-popuptip",
      popupTipBody: n,
      hideTitleDivider: !0,
      placement: "bottom",
      timeout: 1e3,
      children: /* @__PURE__ */ p(
        l,
        {
          ...e,
          iconName: "link",
          renderAs: "button",
          shareToUrl: "",
          className: k(["CopyLink", t]),
          onClick: a,
          onKeyDown: c,
          "data-testid": "copy-link"
        }
      )
    }
  );
}, B = f.div`
  &.ShareLinks {
    ${({
  theme: {
    components: { shareLinks: o }
  }
}) => w(o.ShareLinks)};
  }
`, K = f(g)`
  &.ShareLinks__divider {
    ${({
  theme: {
    components: { shareLinks: o }
  }
}) => w(o.Divider)};
  }
`, q = f.nav`
  &.ShareLinks__links {
    ${({
  theme: {
    components: { shareLinks: o }
  }
}) => w(o.Links)};
  }
`, u = ({
  title: o = "",
  pageUrl: n = b ? window.location.href : void 0,
  target: t = "_blank",
  children: e,
  className: i,
  ...s
}) => {
  const a = _({ label: "ShareLinks" }), c = y(
    e,
    {
      Facebook: u.ShareIcon.Facebook,
      LinkedIn: u.ShareIcon.LinkedIn,
      Twitter: u.ShareIcon.Twitter,
      CopyLink: u.CopyLink
    },
    y.PickType.LAST
  ), r = y(c.rest, { ShareIcons: u.ShareIcon }), m = S(
    () => D(
      [c.Facebook, c.LinkedIn, c.Twitter, ...r.ShareIcons, c.CopyLink].filter(Boolean),
      (h, d) => ({
        key: d,
        pageUrl: n,
        target: t
      })
    ),
    [c.Facebook, c.LinkedIn, c.Twitter, c.CopyLink, r.ShareIcons, n, t]
  );
  return /* @__PURE__ */ C(
    B,
    {
      ...a,
      ...s,
      className: k(["ShareLinks", i]),
      children: [
        (o == null ? void 0 : o.trim().length) > 0 && /* @__PURE__ */ p(
          x,
          {
            size: "medium",
            fontWeight: "semi-bold",
            className: "ShareLinks__title",
            children: o
          }
        ),
        (o == null ? void 0 : o.trim().length) > 0 && /* @__PURE__ */ p(K, { className: "ShareLinks__divider" }),
        /* @__PURE__ */ p(q, { className: "ShareLinks__links", children: m })
      ]
    }
  );
};
u.ShareIcon = l;
u.CopyLink = j;
export {
  u as ShareLinks
};
